/**
 * SSE 流式消息 payload 解析工具
 */
import type { StreamingMessageResponse } from '@/types/formulation/formulation';

/**
 * 从 SSE onMessage 入参中解析出业务 payload（兼容 SSEResponse<string> 与直接 payload 对象）
 */
export const getStreamPayload = (m: unknown): StreamingMessageResponse | null => {
  if (!m || typeof m !== 'object') return null;
  const obj = m as Record<string, unknown>;
  if (obj.data != null) {
    const d = obj.data;
    if (typeof d === 'string') {
      try {
        return JSON.parse(d) as StreamingMessageResponse;
      } catch {
        return null;
      }
    }
    if (typeof d === 'object' && d !== null && 'business_type' in (d as object)) {
      return d as unknown as StreamingMessageResponse;
    }
  }
  if ('business_type' in obj) return obj as unknown as StreamingMessageResponse;
  return null;
};
